import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChartSegment = () => {
  return (
    <g>
      <path d="m14.12 9.3642a.7517.7517 0 0 0 -.9072.55 5.8884 5.8884 0 1 1 -7.3105-7.0793.75.75 0 0 0 -.4043-1.4443 7.3886 7.3886 0 1 0 9.172 8.8809.75.75 0 0 0 -.55-.9073z" />
      <path d="m8.5049.1074a.75.75 0 0 0 -.75.75v6.6377a.75.75 0 0 0 .75.75h6.6377a.75.75 0 0 0 .75-.75 7.3962 7.3962 0 0 0 -7.3877-7.3877zm.75 6.6377v-5.09a5.9 5.9 0 0 1 5.09 5.09z" />
    </g>
  );
};

export default withIcon(IconChartSegment);
